/**
 * La campagne de cette visite — 06/09/2026.
 *
 * L'arrivée portant `utm_campaign` était comptée une fois, puis oubliée : on
 * savait combien de gens une annonce avait amenés, jamais combien avaient
 * fini leur diagnostic ni acheté. Le libellé de campagne, réduit à un
 * identifiant sûr, est retenu pour la durée de l'onglet et joint à chaque
 * évènement et à chaque appel qui compte — jamais au-delà de la session, et
 * jamais avec un traceur tiers.
 *
 * Ce module n'importe rien : il est lu par `track` et par `campagne`, qui
 * s'importent l'un l'autre.
 */
const CLE = "stratera.campagne";
const LONGUEUR_MAX = 24;

let courante: string | null = null;

/** L'identifiant que les compteurs acceptent : minuscules, chiffres, tirets. */
export function slugCampagne(valeur: string | null | undefined): string | null {
  if (typeof valeur !== "string") return null;
  const slug = valeur
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, LONGUEUR_MAX)
    .replace(/-+$/g, "");
  return slug.length >= 2 ? slug : null;
}

/**
 * L'annonce indépendant arrive réglée sur « À mon compte » — 09/10/2026.
 *
 * Elle promet « ce que vos clients vous achètent » et atterrissait sur un
 * accueil réglé sur « Salarié », avec un chapeau écrit pour un salarié.
 */
export function aSonCompteDepuisCampagne(slug: string | null): boolean {
  return slug !== null && slug.startsWith("independant");
}

export function memoriserCampagne(valeur: string | null | undefined): void {
  const slug = slugCampagne(valeur);
  if (slug === null) return;
  courante = slug;
  try {
    sessionStorage.setItem(CLE, slug);
  } catch {
    // Stockage indisponible : la mémoire du module tient le temps de la page.
  }
}

export function campagneCourante(): string | null {
  if (courante !== null) return courante;
  try {
    courante = slugCampagne(sessionStorage.getItem(CLE));
  } catch {
    courante = null;
  }
  return courante;
}

/** Pour les tests : repartir sans campagne. */
export function oublierCampagne(): void {
  courante = null;
  try {
    sessionStorage.removeItem(CLE);
  } catch {
    // Rien à oublier.
  }
}
